import { render, staticRenderFns } from "./customInsureApplyQuery.vue?vue&type=template&id=523d52f4&scoped=true&"
import script from "./customInsureApplyQuery.vue?vue&type=script&lang=js&"
export * from "./customInsureApplyQuery.vue?vue&type=script&lang=js&"
import style0 from "./customInsureApplyQuery.vue?vue&type=style&index=0&id=523d52f4&lang=scss&scoped=true&"
import style1 from "./customInsureApplyQuery.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523d52f4",
  null
  
)

export default component.exports